// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: yB3-yZo7Q8
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicInputFiled.module.css"; // plasmic-import: yB3-yZo7Q8/css

export type PlasmicInputFiled__VariantMembers = {};

export type PlasmicInputFiled__VariantsArgs = {};
type VariantPropType = keyof PlasmicInputFiled__VariantsArgs;
export const PlasmicInputFiled__VariantProps = new Array<VariantPropType>();

export type PlasmicInputFiled__ArgsType = {};
type ArgPropType = keyof PlasmicInputFiled__ArgsType;
export const PlasmicInputFiled__ArgProps = new Array<ArgPropType>();

export type PlasmicInputFiled__OverridesType = {
  root?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  input?: p.Flex<"input">;
};

export interface DefaultInputFiledProps {
  className?: string;
}

function PlasmicInputFiled__RenderFunc(props: {
  variants: PlasmicInputFiled__VariantsArgs;
  args: PlasmicInputFiled__ArgsType;
  overrides: PlasmicInputFiled__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      {true ? (
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          <input
            data-plasmic-name={"input"}
            data-plasmic-override={overrides.input}
            className={classNames(projectcss.all, projectcss.input, sty.input)}
            placeholder={"" as const}
            size={1 as const}
            title={"" as const}
            type={"text" as const}
            value={"" as const}
          />
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "input"],
  freeBox: ["freeBox", "input"],
  input: ["input"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  input: "input";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicInputFiled__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicInputFiled__VariantsArgs;
    args?: PlasmicInputFiled__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicInputFiled__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicInputFiled__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicInputFiled__ArgProps,
          internalVariantPropNames: PlasmicInputFiled__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicInputFiled__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInputFiled";
  } else {
    func.displayName = `PlasmicInputFiled.${nodeName}`;
  }
  return func;
}

export const PlasmicInputFiled = Object.assign(
  // Top-level PlasmicInputFiled renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    input: makeNodeComponent("input"),

    // Metadata about props expected for PlasmicInputFiled
    internalVariantProps: PlasmicInputFiled__VariantProps,
    internalArgProps: PlasmicInputFiled__ArgProps
  }
);

export default PlasmicInputFiled;
/* prettier-ignore-end */
